module.exports = "/_next/static/images/3701bd55354ea987403f82683a2ac7ae-pregnant-woman@mobile@3x.jpg";